import React from "react";
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import FormControl from '@mui/material/FormControl';

const MuiDaterange = ({
  name,
  label,
  disabled = false,
  required = false,
  disableFuture = true,
  value,
  onChange,
  onKeyUp,
  format = "DD-MM-YYYY",
  clearable = true,
  fullWidth = true,
  sx = {},
  style = {},
  minDate,
  maxDate
}) => {

  const defaultStyles = {
    backgroundColor: "#FFF",
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "black", // For WebKit browsers
    },
    ...sx,
  };

  return (
    <FormControl fullWidth>
    <DateRangePicker
      label={label}
      name={name}
      disabled={disabled}
      disableFuture={disableFuture}
      required={required}
      value={value}
      format={format}
      clearable={clearable}
      fullWidth={fullWidth}
      onChange={onChange}
      onKeyUp={onKeyUp}
      sx={defaultStyles}
      style={style}
      minDate={minDate}
      maxDate={maxDate}
    />
    </FormControl>
  );
};

export default MuiDaterange;